module.exports = __webpack_public_path__ + "img/shirt-2.0826b04a.jpg";